// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"TradeTypeFilter--next-sr-only--1QxKbZk","select":"TradeTypeFilter--select--1mBX2VP"};